import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

const BLUE_GRADIENT = ["#2563eb", "#06b6d4"]
const STATUS_COLORS = {
  finished: "#2563eb",
  dnf: "#f59e0b",
  dns: "#06b6d4",
  disqualified: "#ef4444",
  query: "#8b5cf6",
  other: "#64748b"
}

export default class extends Controller {
  static values = {
    type: String,
    labels: Array,
    values: Array
  }

  connect() {
    this.render()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }

  render() {
    const canvas = this.element
    const context = canvas.getContext("2d")

    this.chart = new Chart(context, {
      type: this.typeValue,
      data: this.chartData(context),
      options: this.chartOptions()
    })
  }

  chartData(context) {
    if (this.typeValue === "bar") {
      return {
        labels: this.labelsValue,
        datasets: [{
          label: "Results",
          data: this.valuesValue,
          borderRadius: 10,
          borderSkipped: false,
          backgroundColor: this.verticalGradient(context),
          hoverBackgroundColor: "#1d4ed8",
          maxBarThickness: 36
        }]
      }
    }

    return {
      labels: this.labelsValue,
      datasets: [{
        data: this.valuesValue,
        backgroundColor: this.labelsValue.map((label) => STATUS_COLORS[label.toLowerCase()] || STATUS_COLORS.other),
        borderColor: "#ffffff",
        borderWidth: 4,
        hoverOffset: 10
      }]
    }
  }

  chartOptions() {
    const shared = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: this.typeValue !== "bar",
          position: "bottom",
          labels: {
            boxWidth: 10,
            boxHeight: 10,
            color: "#475569",
            font: { weight: "600" },
            padding: 18,
            usePointStyle: true
          }
        },
        tooltip: {
          backgroundColor: "#0f172a",
          borderColor: "rgba(255,255,255,0.12)",
          borderWidth: 1,
          padding: 12,
          titleColor: "#ffffff",
          bodyColor: "#cbd5e1",
          displayColors: false
        }
      }
    }

    if (this.typeValue !== "bar") {
      return {
        ...shared,
        cutout: "62%"
      }
    }

    return {
      ...shared,
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: "#64748b", font: { weight: "700" } },
          border: { display: false }
        },
        y: {
          beginAtZero: true,
          grid: { color: "rgba(148,163,184,0.18)" },
          ticks: { color: "#64748b", precision: 0 },
          border: { display: false }
        }
      }
    }
  }

  verticalGradient(context) {
    const gradient = context.createLinearGradient(0, 0, 0, 360)
    gradient.addColorStop(0, BLUE_GRADIENT[0])
    gradient.addColorStop(1, BLUE_GRADIENT[1])
    return gradient
  }
}
